// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_14iPu","visuallyhidden":"_1BYLh","hide-text":"_31GkR","center":"_1Z4da","noprint":"_3uJrl","root":"uPJfJ","carousel":"_1uRFp","button":"_349Al","buttonPrevious":"_1JMIk","buttonNext":"_112o9","videoSlide":"_2I3Ck","buttonContent":"_1a1Y7","slides":"_3QALe","statusBar":"_2f8As","caption":"_1W8NG","byline":"_1vHcZ","state":"_1UBL6"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-gallery/styles/gallery/default.scss
 ** module id = 1001
 ** module chunks = 2
 **/